/**
 * @author Sarthak Sharma.
 * @since 31-01-2024.
 * @type {string} PROFILE action types.
 */

export const SET_LOADING = '[ARTIST_PROFILE] SET_LOADING';
export const SET_PROFILE_DATA = '[ARTIST_PROFILE] SET_PROFILE_DATA';
export const SET_PROFILE_METADATA = '[ARTIST_PROFILE] SET_PROFILE_METADATA';

export const SET_SELECTED_EDUCATION_DATA = '[ARTIST_PROFILE] SET_SELECTED_EDUCATION_DATA';
export const SET_SELECTED_WORKDONE_DATA = '[ARTIST_PROFILE] SET_SELECTED_WORKDONE_DATA';
export const SET_WORKDONE_LIST = '[ARTIST_PROFILE] SET_WORKDONE_LIST';

